export function latinize(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function isLatinized(str: string): boolean {
  return str === latinize(str);
}

export const latinStringHelper = {
  latinize,
  isLatinized,
};
